import { predicate, string } from "fp-ts"

export const isNonEmpty = predicate.not(string.isEmpty)
